import React, { FunctionComponent } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { ProductFormAmountInput } from 'components/productFormFields';
import { FinancesComponentsProps } from '../types';
import { CURRENCIES } from '../../../utils/constants';
import { Label } from '@nbc-design/label';
import { createErrorFormatter } from '../../../utils/productFormUtils';

const AnnualRevenue: FunctionComponent<FinancesComponentsProps> = (props: FinancesComponentsProps) => {
  const { intl, getText } = props;
  const formatErrorMessage = createErrorFormatter(intl, 'annualRevenue', undefined, true);

  return (
    <Row>
      <Col xs={12} md={12} lg={12} data-test="field_annualRevenue">
        <div className="label-text">
          <Label htmlFor="AmountInput-annualRevenueAmount" className="my-0">
            {getText('annualRevenue')}
          </Label>
        </div>
        <Row>
          <Col xs={6} sm={6} md={6} lg={6}>
            <ProductFormAmountInput
              name="annualRevenue"
              suffix={CURRENCIES.CAD}
              className="annualRevenue"
              formatErrorMessage={formatErrorMessage}
              placeholder={getText('annualRevenuePlaceholder')}
              fractionDigit={0}
              preventDecimal
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AnnualRevenue;
